import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { ITemplateQuestion } from 'components/CheckListForm/interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IChecklistApplication, IConfluenceArticle, IDefectType } from './interfaces';

export const getChecklistApplicationList = (data: IDynamicTableParams) => {
  return instance()
    .post<IChecklistApplication[]>('/checkListApplication/list', data)
    .then((response) => response.data);
};

export const getChecklistApplicationListAll = () => {
  return instance()
    .post<IChecklistApplication[]>('/checkListApplication/listAll')
    .then((response) => response.data);
};

export const getChecklistApplicationListAllNotDeleted = () => {
  return instance()
    .post<IChecklistApplication[]>('/checkListApplication/listAllNotDeleted')
    .then((response) => response.data);
};

export const getChecklistApplicationAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/checkListApplication/availableColumns')
    .then((response) => response.data);
};

export const getChecklistApplicationAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/checkListApplication/availableGroupColumns')
    .then((response) => response.data);
};

// Ответ загрузки: вопросы приходят в виде API (ITemplateQuestion)
type IChecklistApplicationLoaded = { works: { workName: string; stages: ITemplateQuestion[] }[] } & Omit<
  IChecklistApplication,
  'works'
>;

export const loadChecklistApplication = (checkListId: number) => {
  return instance()
    .get<IChecklistApplicationLoaded>(`/checkListApplication/load/${checkListId}`)
    .then((response) => response.data);
};

export const createChecklistApplication = (checkList: IChecklistApplication) => {
  return instance()
    .post<IChecklistApplication>(`/checkListApplication/save`, checkList)
    .then((response) => response.data);
};

export const updateChecklistApplication = (checkList: IChecklistApplication) => {
  return instance()
    .post<IChecklistApplication>(`/checkListApplication/${checkList.checkListId}/update`, checkList)
    .then((response) => response.data);
};

export const archiveChecklistApplication = (checkListId: number) => {
  return instance()
    .post(`/checkListApplication/archive`, { checkListId })
    .then((response) => response.data);
};

export const recoverChecklistApplication = (checkListId: number) => {
  return instance()
    .post(`/checkListApplication/recover`, { checkListId })
    .then((response) => response.data);
};

export const getConfluenceStandardList = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IConfluenceArticle[]>('/checkListApplication/listStandards', config)
    .then((response) => response.data);
};

export const getConfluenceLessonList = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IConfluenceArticle[]>('/checkListApplication/listLessons', config)
    .then((response) => response.data);
};

export const getConfluenceNotificationScriptList = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IConfluenceArticle[]>('/checkListApplication/listNotifications', config)
    .then((response) => response.data);
};

export const getDefectTypeList = () => {
  return instance()
    .post<IDefectType[]>('/dictionary/defectsByPositionShort', {})
    .then((response) => response.data);
};
